import { useState, useRef, useEffect, useContext } from 'react'
import { isMobile } from 'react-device-detect'

import classNames from 'classnames'

import { AnnouncementContext } from './context/announcementContext'

import styles from './home_hero.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Media from './basic/media'
import Video from './basic/video'
import ScrollAnimation from './layout/scroll_animation'
import Button from './basic/button'
import Image from './basic/image'

function HomeHero(props) {
	const fields = props.fields
	const [selectedOption, setSelectedOption] = useState(fields.dropdown.options[0])
	const [modalOpen, setModalOpen] = useState(false)
	const {announcementHeight, heightChangeHandler} = useContext(AnnouncementContext)
	const heroRef = useRef(null)
	const videoComponentRef = useRef(null)
	const vignetteRef = useRef(null)

	const toggleDropdown = (open) => {
		const dropdown = document.querySelector(`.${styles.dropdown_wrapper}`)

		if (typeof open === 'undefined' || isMobile) {
			open = !dropdown.classList.contains(styles.open)
		}
		
		if (open) {
			dropdown.classList.add(styles.open)
			let itemsHeight = 0
			const options = [...dropdown.querySelector('.dropdown_options').childNodes].slice(1)
			options.forEach(option => {
				itemsHeight += option.offsetHeight + 10
			})
			dropdown.style.height = 60 + itemsHeight + 'px'
		} else {
			dropdown.style.height = '60px'
			dropdown.classList.remove(styles.open)
		}
	}

	const toggleVideoModal = () => {
		setModalOpen(!modalOpen)
		document.body.classList.toggle('overlay_open')
		if (modalOpen) {
			if (videoComponentRef.current) {
				videoComponentRef.current.pause()
			}
		} else {
			if (videoComponentRef.current) {
				videoComponentRef.current.play()
			}
		}
	}

	useEffect(() => {
		setTimeout(() => {
			heroRef.current.classList.add(styles.animate_in)
		}, 2000)
	}, [])

	return <BlockWrapper {...props} className={classNames(styles.front_hero, styles[fields.style], modalOpen ? styles.modal_open : '', props.editor ? styles.editor : '')} style={{marginTop: announcementHeight + 'px', marginBottom: '0px'}}>
		<ScrollAnimation styles={styles}>
			<div className={styles.background_wrapper}>
				<Media videoRef={vignetteRef} settings={{controls: false, autoplay: true, muted: true, loop: true, loading: 'eager'}} {...fields.background_media} className={styles.background_media} />
				<div className={styles.overlay}></div>
			</div>
			<div ref={heroRef} className={styles.content_wrapper}>
				<div className={styles.content_inner}>
					<div className={styles.left_column}>
						{fields.logo && fields.style === 'style_2' && <Image className={styles.logo} {...fields.logo} />}
						<h1 className={styles.heading}>
							<div className={styles.mask}>
							<span className={styles.white} dangerouslySetInnerHTML={{ __html: fields.heading_text.white_text }}></span>
							</div>
							<div className={styles.mask}>
								<span className={styles.green} dangerouslySetInnerHTML={{ __html: fields.heading_text.green_text }}></span>
							</div>
						</h1>
						{fields.style !== 'style_2' && (
						<div className={styles.dropdown_wrapper} onClick={toggleDropdown} onMouseEnter={() => {!isMobile ? toggleDropdown(true) : null}} onMouseLeave={() => {!isMobile ? toggleDropdown(false) : null}}>
							<div className={styles.dropdown_inner}>
								<label>{fields.dropdown.label}</label>
								<div className={classNames("dropdown_options", styles.dropdown_options)}>
									<div className={classNames(styles.option, styles.selected)}><a href={selectedOption.option_link}>{selectedOption.option}</a></div>
									{fields.dropdown.options.map((item, i) => {
										return item.option != selectedOption.option ? <div className={styles.option} key={i}>
											<a href={item.option_link}>{item.option}</a>
										</div> : ''
									})}
								</div>
							</div>
						</div>
						)}
						{fields.style === 'style_2' && fields.call_to_action && (
							<Button 
								fields={{button: fields.call_to_action}} 
								button_style="style_2" 
								color="white" 
								className={styles.call_to_action_button}
							/>
						)}
					</div>
					<div className={styles.right_column}>
						<div className={styles.video_wrapper} onClick={() => {toggleVideoModal()}}>
							<button className={styles.play_button} dangerouslySetInnerHTML={{__html: fields.video_modal.button_label}} />
						</div>
					</div>
				</div>
				<div className={styles.scroll_down}>
					<a onClick={e => {
						let anchor = document.getElementById("anchor")
						e.preventDefault()
						anchor && anchor.scrollIntoView({ behavior: "smooth", block: "start"})
						}}
					>
					</a>
				</div>
			</div>
		</ScrollAnimation>
		<div className={classNames(styles.video_modal, modalOpen ? styles.open : '')}>
			<div className={styles.video_modal_inner}>
				<div className={styles.video_modal_close} onClick={() => {toggleVideoModal()}}></div>
				<div className={styles.video_modal_video}>
					<Video
						ref={videoComponentRef}
						{...fields.video_modal.video}
						video_type={fields.video_modal.video_type}
						vimeo_url={fields.video_modal.vimeo_url}
					/>
				</div>
			</div>
		</div>
	</BlockWrapper>
}

export default HomeHero